import React, { useRef } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function MessageChart({ metrics }) {
  const chartRef = useRef(null);

  // Generate labels with Eastern time in HH:MM format
  const generateTimeLabels = () => {
    const labels = [];
    const now = new Date();
    
    for (let i = 59; i >= 0; i--) {
      const time = new Date(now.getTime() - i * 60 * 1000);
      // Convert to Eastern time
      const easternTime = new Date(time.toLocaleString("en-US", {timeZone: "America/New_York"}));
      const hours = easternTime.getHours().toString().padStart(2, '0');
      const minutes = easternTime.getMinutes().toString().padStart(2, '0');
      labels.push(`${hours}:${minutes}`);
    }
    
    return labels;
  };

  const data = {
    labels: generateTimeLabels(),
    datasets: [
      {
        label: 'Messages per Minute',
        data: metrics.messages_per_minute || Array(60).fill(0),
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'rgba(75, 192, 192, 0.5)',
        tension: 0.1
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Message Throughput (Last Hour)'
      }
    },
    scales: {
      y: {
        beginAtZero: true
      }
    }
  };

  return (
    <div className="dashboard-card full-width">
      <h2>Message Throughput</h2>
      <div className="chart-container">
        <Line ref={chartRef} data={data} options={options} />
      </div>
    </div>
  );
}

export default MessageChart;